
import React from 'react';
import BooleanStep from './BooleanStep';

export default class AdblockGate extends React.Component {
  render() {
    return (
      <BooleanStep
        {...this.props}
        labelText={ 'Adblocked' }
      />
    );
  }
}
